// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5f0685cd","239":"e527af9e","455":"b334433d"}[chunkId] + ".chunk.js";
};